/*

<DoorSizeSelector
    list={doorSizeList}
    handleNext = {(x) => this.calculate(x)} // optional

    // For Controlled components // optional
    idSelected={this.state.doorSizeIdSelected}
    handleChange={(x) => this.setState({doorSizeIdSelected:x})}
/>

 */
import React from 'react'
import FormLabel from '@material-ui/core/FormLabel/FormLabel'
import { strings } from '../../localization/strings'
import Typography from '@material-ui/core/Typography/Typography'
import Radio from '@material-ui/core/Radio/Radio'
import Button from '@material-ui/core/Button/Button'
import boxXS from '../../assets/icons/box-xs.png'
import boxS from '../../assets/icons/box-s.png'
import boxM from '../../assets/icons/box-m.png'
import boxL from '../../assets/icons/box-l.png'
import boxXL from '../../assets/icons/box-xl.png'
import boxNoSize from '../../assets/icons/box-nosize.png'

const selectedSize = (size) => {
    const imgStyle = { width: '90%' }
    switch (size) {
        case 'XS':
            return <img alt="none" src={boxXS} style={imgStyle} />
        case 'S':
            return <img alt="none" src={boxS} style={imgStyle} />
        case 'M':
            return <img alt="none" src={boxM} style={imgStyle} />
        case 'L':
            return <img alt="none" src={boxL} style={imgStyle} />
        case 'XL':
            return <img alt="none" src={boxXL} style={imgStyle} />
        default:
            return <img alt="none" src={boxNoSize} style={imgStyle} />
    }
}

class Component extends React.Component {
    state = {
        idSelected: this.props.idSelected,
    }

    render() {
        let { list, handleChange, handleNext } = this.props
        let idSelected = this.props.idSelected || this.state.idSelected
        let nameSelected = !idSelected
            ? null
            : list.find((x) => x.id === idSelected).name

        const legendStyle = {
            whiteSpace: 'pre-line',
            fontWeight: 'bold',
            fontSize: '0.7em',
            marginTop: '0.2em',
            marginBottom: '0.2em',
        }

        return (
            <div
                style={{
                    border: '2px solid #f7b500',
                    borderRadius: 8,
                    padding: 8,
                }}
            >
                <FormLabel component="legend">
                    {strings.reverseLogisticsSelectSizeTitle}
                </FormLabel>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingTop: 5,
                        paddingBottom: 5,
                    }}
                >
                    <div style={{ flexGrow: 1 }}>
                        {selectedSize(nameSelected)}
                        <Typography color="inherit" style={legendStyle}>
                            {strings.minimumAllowedPackageSize}
                        </Typography>
                    </div>
                    <div style={{ minWidth: 100 }}>
                        {list.map((size, index) => (
                            <div key={index}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                    }}
                                >
                                    <Radio
                                        checked={size.id === idSelected}
                                        inputProps={{ 'aria-label': 'A' }}
                                        onChange={() => {
                                            this.setState({
                                                idSelected: size.id,
                                            })
                                            if (handleChange)
                                                handleChange(size.id)
                                        }}
                                    />
                                    <div style={{ flexGrow: 1 }}>
                                        {size.name}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {!handleNext ? null : (
                    <div style={{ textAlign: 'right' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleNext(idSelected)}
                            disabled={!idSelected}
                        >
                            {strings.reverseLogisticsSelectSizeAccept}
                        </Button>
                    </div>
                )}
            </div>
        )
    }
}

export default Component
